import { GroupOverlap, RefreshGroup } from '@pubstack/common/src/refresh'
import { FunctionComponent } from 'react'
import { Checkbox } from '@pubstack/ui/components/Checkbox'
import { normalizeAsTrackingLabel } from '~/components/layout/ProductTrackingIntegration'
import { toggleValueInArray } from '~/utils/array'

export type RefreshGroupDevice = RefreshGroup['devices'][number]

// legend styling applied when the device overlaps another group
const OverlapLegendClass = 'bg-mew rounded py-1 pr-2.5 pl-0'

export const RefreshGroupDevicesForm: FunctionComponent<{
  deviceList: RefreshGroupDevice[]
  refreshGroupDevices: RefreshGroupDevice[]
  updateRefreshGroup: (device: RefreshGroupDevice[]) => unknown
  overlap: GroupOverlap
}> = ({ deviceList, refreshGroupDevices, updateRefreshGroup, overlap }) => {
  // building checkboxes: we check ad units that are in refresh group's ones, then filter them according to the search value
  const options = deviceList.map((s) => ({ label: s.name, value: s.id, checked: refreshGroupDevices.some((rs) => rs.id === s.id) }))

  const onToggle = (device: RefreshGroupDevice) => {
    // toggling the device
    const newDevices = toggleValueInArray(refreshGroupDevices, device, 'id')

    // dispatch the new value
    updateRefreshGroup(newDevices)
  }

  const onSelectAll = () => {
    if (options.every((o) => o.checked)) {
      updateRefreshGroup([])
    } else {
      updateRefreshGroup(deviceList)
    }
  }

  return (
    <>
      <Checkbox
        checked={options.every((o) => o.checked)}
        label={'Select all'}
        onClick={onSelectAll}
        trackingLabel={options.every((o) => o.checked) ? 'common-settings-refresh-groups-all-device-unset' : 'common-settings-refresh-groups-all-device-set'}
      />
      {options.map((option, index) => {
        const isOverlap = overlap.devices.includes(option.value) && option.checked
        return (
          <Checkbox
            className={isOverlap ? OverlapLegendClass : undefined}
            variant={isOverlap ? 'alert' : 'primary'}
            onClick={() => onToggle({ id: option.value, name: option.label })}
            key={`${option.value}${index}`}
            checked={option.checked}
            label={option.label}
            trackingLabel={
              option.checked
                ? `common-settings-refresh-groups-device-${normalizeAsTrackingLabel(option.label)}-unset`
                : `common-settings-refresh-groups-device-${normalizeAsTrackingLabel(option.label)}-set`
            }
          />
        )
      })}
    </>
  )
}
